// RISKS.md/P2.79: the join ticket is a bearer credential, so the meeting room's address must not
// carry it. sessionStorage keeps it for this tab's ways back to the green room: a reload keeps it,
// a duplicated tab or a window this tab opens copies it, and a tab opened afresh has none.
const KEY = 'join-ticket'

export const storeJoinTicket = (ticket: string) => sessionStorage.setItem(KEY, ticket)

export const readJoinTicket = (): string | null => sessionStorage.getItem(KEY)

// Encoded: the router decodes %2F into the param, so a ticket holding a slash would stop matching
// /join/:token and bounce between /meeting and the catch-all for ever.
export const joinPath = (ticket: string) => `/join/${encodeURIComponent(ticket)}`
